import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import Select from 'react-select';
import api from '../../api';
/* actions */
import { editBreeds } from '../../redux/actions/breeds';
import { getAllSpecies } from '../../redux/actions/species';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/breed';
/* utils */
import {
  customStyle,
  customThemes,
  customFilter,
  firstOption,
  handleChangeSelect
} from '../../utils/select';
import sortable from '../../utils/sortable';
import handleChangeDefault from '../../utils/handleChangeDefault';

function Edit (props) {
  const { id } = props.match.params;
  const INITIAL_VALUES = {
    _id: id || '',
    name: '',
    specie: '',
    company: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, setError, setValue } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const breeds = useSelector(state => state.breeds);
  const [data, setData] = useState(INITIAL_VALUES);
  const species = useSelector(state => state.species.data);
  const [specieOptions, setSpecieOptions] = useState([firstOption]);

  useEffect(() => {
    dispatch(getAllSpecies({ company }));
  }, [dispatch]);

  useEffect(() => {
    (async function () {
      try {
        const params = { _id: id };
        const { data } = await api().get('/api/breeds', { params });
        if (data[0]) {
          const newData = {
            ...INITIAL_VALUES,
            ...data[0],
            specie: data[0].specie._id
          };
          setData(newData);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    })();
  }, []);

  useEffect(() => {
    if (species.length) {
      const options = species
        .map(specie => ({
          value: specie._id,
          label: `${specie.name}`,
          sortValue: `${specie.name}`
        }))
        .sort(sortable);

      options.unshift(firstOption);
      setSpecieOptions([...options]);
    }
  }, [species, setSpecieOptions]);

  const submit = () => {
    dispatch(editBreeds(data, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {breeds.editSuccess && (
        <AlertMsg type="success" msg="Raça atualizada com sucesso" />
      )}
      {breeds.errorContent &&
        !breeds.errorContent.message.includes('400') &&
        breeds.editError && (
        <AlertMsg type="danger" msg="Falha durante atualização da raça" />
      )}
      {breeds.errorContent &&
        breeds.errorContent.message.includes('400') &&
        breeds.editError && (
        <AlertMsg
          type="danger"
          msg="Uma raça com o nome informado já está cadastrada"
        />
      )}
      {!breeds.editSuccess && !breeds.editError && (
        <AlertMsg type="info" msg="Área atualização de raças" />
      )}
      <FormHeader title="Atualizar Raça" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="specie">
            Espécie<span className="field-required">*</span>
          </label>
          <Select
            name="breed-specie"
            ref={register}
            onChange={evt =>
              handleChangeSelect(
                { ...evt, name: 'specie' },
                data,
                setData,
                setError,
                setValue
              )
            }
            defaultValue={specieOptions[0]}
            value={specieOptions.find(specie => specie.value === data.specie)}
            options={specieOptions}
            isSearchable={true}
            theme={customThemes}
            styles={customStyle}
            filterOption={customFilter}
            noOptionsMessage={() => 'Nenhum registro encontrado'}
          />
          {errors.specie && errors.specie.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            value={data.name}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <FormFooter url="/breeds" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
